module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_4-7f09d1b8a2fa492da4e17220127ed058.png";